import { render, staticRenderFns } from "./CreateOrganizationInfo.vue?vue&type=template&id=0d0c11d9&scoped=true"
import script from "./CreateOrganizationInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateOrganizationInfo.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CreateOrganizationInfo.vue?vue&type=style&index=0&id=0d0c11d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0c11d9",
  null
  
)

export default component.exports